import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { YIELD_BUDGET_MS } from '../config';
/**
 * Plain bounded-concurrency pool with viewport-priority reordering and
 * time-sliced yielding so a Blob source (memcpy-fast reads) can't monopolize
 * frames with back-to-back YAML parses.
 */
export function createHydrationScheduler(opts) {
  var _opts$yieldBudgetMs;
  var concurrency = opts.concurrency,
    task = opts.task;
  var yieldBudget = (_opts$yieldBudgetMs = opts.yieldBudgetMs) !== null && _opts$yieldBudgetMs !== void 0 ? _opts$yieldBudgetMs : YIELD_BUDGET_MS;
  var controller = new AbortController();
  var listeners = new Set();
  var progress = {
    total: 0,
    done: 0,
    failed: 0
  };
  var pending = [];
  var running = 0;
  var aborted = false;
  var lastYield = typeof performance !== 'undefined' ? performance.now() : Date.now();
  var now = function now() {
    return typeof performance !== 'undefined' ? performance.now() : Date.now();
  };
  var notify = function notify() {
    var snapshot = _objectSpread({}, progress);
    var _iterator = _createForOfIteratorHelper(listeners),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _cb = _step.value;
        _cb(snapshot);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var launch = function launch(id) {
    running += 1;
    task(id, controller.signal).then(function () {
      progress.done += 1;
    }, function () {
      progress.failed += 1;
    })["finally"](function () {
      running -= 1;
      notify();
      void pump();
    });
  };
  var pump = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!aborted && running < concurrency && pending.length > 0)) {
              _context.next = 3;
              break;
            }
            if (!(now() - lastYield > yieldBudget)) {
              _context.next = 2;
              break;
            }
            lastYield = now();
            _context.next = 1;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 0);
            });
          case 1:
            return _context.abrupt("continue", 0);
          case 2:
            launch(pending.shift());
            _context.next = 0;
            break;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function pump() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    enqueue: function enqueue(ids) {
      var _pending;
      if (aborted) return;
      (_pending = pending).push.apply(_pending, _toConsumableArray(ids));
      progress.total += ids.length;
      notify();
      void pump();
    },
    prioritize: function prioritize(ids) {
      if (aborted || ids.length === 0) return;
      var wanted = new Set(ids);
      var front = [];
      var rest = [];
      for (var _i = 0, _pending2 = pending; _i < _pending2.length; _i++) {
        var id = _pending2[_i];
        (wanted.has(id) ? front : rest).push(id);
      }
      if (front.length === 0) return;
      // Keep the caller's order for the moved group (top of viewport first).
      front.sort(function (a, b) {
        return ids.indexOf(a) - ids.indexOf(b);
      });
      pending = [].concat(front, rest);
    },
    abort: function abort() {
      aborted = true;
      pending = [];
      controller.abort();
    },
    onProgress: function onProgress(cb) {
      listeners.add(cb);
      return function () {
        return listeners["delete"](cb);
      };
    }
  };
}